
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.091 16C21.661 15.964 24 12.484 24 9.5a3.5 3.5 0 00-2.764-3.419c.136-.387.254-.742.333-1.011a3.887 3.887 0 00-.626-3.458A3.979 3.979 0 0017.729 0H6.271a3.979 3.979 0 00-3.214 1.612 3.887 3.887 0 00-.626 3.458c.079.269.2.624.333 1.011A3.5 3.5 0 000 9.5c0 2.984 2.339 6.464 8.909 6.5a5.06 5.06 0 01.091.921V20a1.883 1.883 0 01-2 2H6a1 1 0 000 2h12a1 1 0 000-2h-.992A1.885 1.885 0 0115 20v-3.08a5.058 5.058 0 01.091-.92zM20.5 8A1.5 1.5 0 0122 9.5c0 2.034-1.609 4.2-6.036 4.47a4.847 4.847 0 01.762-.821 15.132 15.132 0 003.727-5.159c.016.001.03.01.047.01zM2 9.5A1.5 1.5 0 013.5 8c.017 0 .031-.009.047-.01a15.132 15.132 0 003.727 5.159 4.847 4.847 0 01.762.821C3.609 13.7 2 11.534 2 9.5zM10.513 22A4.08 4.08 0 0011 20v-3.079a6.93 6.93 0 00-2.431-5.295A15.338 15.338 0 014.349 4.5a1.9 1.9 0 01.31-1.694A1.994 1.994 0 016.271 2h11.458a1.994 1.994 0 011.612.81 1.9 1.9 0 01.31 1.694 15.338 15.338 0 01-4.22 7.122A6.928 6.928 0 0013 16.92V20a4.08 4.08 0 00.487 2z"}})])
          )
        }
      }
    